<template>
  <div class="base">
    <v-facebook-login
      app-id="237731426239115"
      :login-options="this.fb_obj"
      @login="onLogin"
      @sdk-init="sdkLoaded"
      @logout="onLogout"
    ></v-facebook-login>
  </div>
</template>

<script>
import { VFBLogin as VFacebookLogin } from "vue-facebook-login-component";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VFacebookLogin
  },
  data() {
    return {
      FB: undefined,
      fb_obj: {
        scope: []
      }
    };
  },
  computed: {
    ...mapGetters(["getFbId"])
  },
  methods: {
    ...mapActions(["faceBookLogin"]),
    sdkLoaded(payload) {
      this.FB = payload.FB;
      var master = this;
      this.FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          master.getUserData();
        }
      });
    },
    getUserData() {
      var master = this;
      this.FB.api("/me", "GET", { fields: "id,name" }, userInformation => {
        master.faceBookLogin(userInformation);
        master.personalID = userInformation.id;
        master.name = userInformation.name;
      });
    },
    onLogin() {
      this.getUserData();
      this.isConnected = true;
    },
    onLogout() {
      this.isConnected = false;
    }
  },
  name: "Facebook"
};
</script>

<style scoped>
.base {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
}
</style>